import { CSSProperties } from "@material-ui/core/styles/withStyles";

// styles
import { greys } from "@clockwise/web-commons/src/styles/color.styles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";

export const menus: CSSProperties = {
  display: "flex",
  alignItems: "center",
};

export const menu: CSSProperties = {
  marginTop: spacing.sm,
};

export const advancedMenu: CSSProperties = {
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  fontSize: "15px",
  color: greys.slate,

  "@media (max-width: 768px)": {
    display: "none",
  },
};

export const menuItemTypography: CSSProperties = {};

export const menuItemIcon: CSSProperties = {
  color: greys.slate,
};

export const menuExpandIcon: CSSProperties = {
  color: greys.slate,
  marginLeft: 4,
  marginRight: 24,
};

export const menuDivider: CSSProperties = {
  marginTop: 6,
  marginBottom: 6,
};

export const menuHeader: CSSProperties = {
  marginLeft: 18,
};

export const avatar: CSSProperties = {
  cursor: "pointer",
};

export const styles = {
  avatar,
  menus,
  menu,
  menuDivider,
  menuHeader,
  advancedMenu,
  menuItemTypography,
  menuItemIcon,
  menuExpandIcon,
};
